import dayjs from 'dayjs';
import validators from '.';
import { QuestionnaireQuestions, Validation } from '../models';

export type ValidationResult =
  | { type: 'Valid' }
  | { type: 'Invalid' | 'Error' | 'Info'; msg: string };

const DATE_FORMAT = 'DD MMM YYYY';

export const runValidation = <T, Questionnaire extends QuestionnaireQuestions>(
  validations: Validation[],
  answer: T,
  answers: Partial<Questionnaire>
): ValidationResult => {
  for (const validator of validations) {
    if (validator.op === 'DateIsInFuture') {
      const isValid = validators.dateIsInFuture.fn(
        answer as string,
        dayjs().format(DATE_FORMAT)
      );
      if (!isValid) {
        const msg = validators.dateIsInFuture.msg(validator.msg.value);
        return { type: validator.msg.type, msg };
      }
    }

    if (validator.op === 'DateIsInPast') {
      const isValid = validators.dateIsInPast.fn(
        answer as string,
        dayjs().format(DATE_FORMAT)
      );
      if (!isValid) {
        const msg = validators.dateIsInFuture.msg(validator.msg.value);
        return { type: validator.msg.type, msg };
      }
    }

    if (validator.op === 'dateDiff') {
      const comparisonValue = validator.variable.comparisonKey
        ? answers[validator.variable.comparisonKey]
        : undefined;
      const isValid = validators.dateDiff.fn(
        answer as string,
        validator.variable.value,
        validator.variable,
        comparisonValue ? String(comparisonValue) : undefined
      );
      if (!isValid) {
        const msg = validator.msg
          ? validators.dateDiff.msg(validator.msg.value)
          : 'Error in dateDiff';
        return { type: validator.msg ? validator.msg.type : 'Invalid', msg };
      }
    }

    if (validator.op === 'Custom') {
      const isValid = validator.fn(answer, answers);

      if (!isValid) {
        return validator.msg
          ? { ...validator.msg(answer, answers) }
          : { type: 'Invalid', msg: 'Error in custom validation' };
      }
    }

    if (validator.op === 'Equals') {
      const isValid = validators.equals.fn(
        answer,
        validator.variable.comparisonValue
      );
      if (!isValid) {
        const msg = validators.equals.msg(
          validator.msg.value,
          answer,
          validator.variable.comparisonValue
        );
        return { type: validator.msg.type, msg };
      }
    }

    if (validator.op === 'NotEquals') {
      const isValid = validators.notEquals.fn(
        answer,
        validator.variable.comparisonValue
      );
      if (!isValid) {
        const msg = validators.notEquals.msg(
          validator.msg.value,
          answer,
          validator.variable.comparisonValue
        );
        return { type: validator.msg.type, msg };
      }
    }
  }
  return { type: 'Valid' };
};
